import waRequest from './wa-request';

export const baseApi = '/communicator-billing/v1';

function initiateReport({organizationId, data}) {
  const url = `${baseApi}/reports`;

  return waRequest
    .requestAuthenticated({
      url,
      method: 'post',
      params: {organizationId},
      data,
    })
    .then((result) => {
      if (result?.data?.jobId) {
        result.data.id = result.data.jobId;
      }
      return result;
    });
}

function getReportStatus({id, successCallback, organizationId}) {
  const url = `${baseApi}/reports/${id}`;

  return waRequest.requestWithRetryUntilSuccess({url, method: 'get', params: {organizationId}}, successCallback, 5000);
}

export default {
  initiateReport,
  getReportStatus,
};
